/**
 * localStorage 키 상수 및 유틸리티
 *
 * 네임스페이스 접두사로 다른 앱과 충돌 방지
 */

// localStorage 키 상수
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'raoom_manage_access_token',
  REFRESH_TOKEN: 'raoom_manage_refresh_token',
  DEVICE_ID: 'raoom_manage_device_id',
  TOKEN_EXPIRES_AT: 'raoom_manage_token_expires_at',
  USER_DATA: 'raoom_manage_user_data',
  USER_ID: 'raoom_manage_userId',
  AUTHORITY: 'raoom_manage_authority',
};

/**
 * 토큰 관련 데이터 가져오기
 */
export function getTokenData() {
  return {
    accessToken: localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
    refreshToken: localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
    deviceId: localStorage.getItem(STORAGE_KEYS.DEVICE_ID),
    tokenExpiresAt: localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT),
  };
}

/**
 * 토큰 만료 여부 확인
 */
export function isTokenExpired() {
  const tokenExpiresAt = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
  if (!tokenExpiresAt) return true;
  return new Date(tokenExpiresAt) < new Date();
}

/**
 * 토큰 저장
 */
export function saveTokens({ accessToken, refreshToken, expiresIn }) {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  localStorage.setItem(
    STORAGE_KEYS.TOKEN_EXPIRES_AT,
    new Date(Date.now() + expiresIn * 1000).toISOString()
  );
}

/**
 * 인증 데이터 삭제
 */
export function clearAuthData() {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.DEVICE_ID);
  localStorage.removeItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
  localStorage.removeItem(STORAGE_KEYS.USER_DATA);
  localStorage.removeItem(STORAGE_KEYS.USER_ID);
  localStorage.removeItem(STORAGE_KEYS.AUTHORITY);
}
